import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";

import { CourseWeekPage } from "~/components/learning/course-week-page";
import { myCourseWeekQueryOptions } from "~/lib/queries/learningQuery";

/** The week number in the address, or null when it is not one. */
function parseWeekNumber(raw: string): number | null {
  return /^[1-9]\d*$/.test(raw) ? Number(raw) : null;
}

export const Route = createFileRoute(
  "/_user/my-coaching/business/courses/$courseSlug/weeks/$weekNumber",
)({
  staticData: { title: "Week" },
  loader: async ({ context, params }) => {
    const number = parseWeekNumber(params.weekNumber);
    if (number === null) throw notFound();
    const week = await context.queryClient.ensureQueryData(
      myCourseWeekQueryOptions(params.courseSlug, number),
    );
    if (!week) throw notFound();
    return { title: `Week ${number}: ${week.week.title}`, number };
  },
  component: CourseWeekRoute,
});

function CourseWeekRoute() {
  const { courseSlug } = Route.useParams();
  const { number } = Route.useLoaderData();
  const { data } = useSuspenseQuery(
    myCourseWeekQueryOptions(courseSlug, number),
  );
  if (!data) throw notFound();
  return <CourseWeekPage data={data} />;
}
